// extracted by mini-css-extract-plugin
export default {"overridesPrimaryDropdownMenuItem":"PrimaryDropdownMenuItem-module--overrides--PrimaryDropdownMenuItem--5fmMH"};